(() => {

  'use strict';



  /*

   * ============================================================

   * LvsH CONFIGURATOR

   * ============================================================

   */



  function getConfiguratorSettings(configurator) {

    const settingsElement =

      configurator.querySelector(

        '[data-lvsh-configurator-settings]'

      );



    if (!settingsElement) {

      console.error(

        '[LvsH Configurator] Settings JSON not found.',

        configurator

      );

      return null;

    }



    try {

      return JSON.parse(

        settingsElement.textContent

      );

    } catch (error) {

      console.error(

        '[LvsH Configurator] Could not parse settings JSON:',

        error

      );

      return null;

    }

  }





  /*

   * ============================================================

   * INITIALISE ALL CONFIGURATORS

   * ============================================================

   */



  function initAllConfigurators(scope = document) {

    const configurators = [];



    if (

      scope instanceof Element &&

      scope.matches('[data-lvsh-configurator]')

    ) {

      configurators.push(scope);

    }



    if (scope.querySelectorAll) {

      scope

        .querySelectorAll(

          '[data-lvsh-configurator]'

        )

        .forEach((configurator) => {

          if (

            !configurators.includes(

              configurator

            )

          ) {

            configurators.push(

              configurator

            );

          }

        });

    }



    configurators.forEach(

      (configurator) => {

        initConfigurator(

          configurator

        );

      }

    );

  }





  /*

   * ============================================================

   * INITIALISE CONFIGURATOR

   * ============================================================

   */



  function initConfigurator(

    configurator

  ) {

    if (

      !configurator ||

      configurator.dataset.initialized ===

        'true'

    ) {

      return;

    }



    const config =

      getConfiguratorSettings(

        configurator

      );



    if (!config) {

      return;

    }



    const sectionId =

      String(

        config.sectionId || ''

      );



    if (!sectionId) {

      console.error(

        '[LvsH Configurator] No section ID found.'

      );

      return;

    }



    configurator.dataset.initialized =

      'true';





    /*

     * ----------------------------------------------------------

     * LOCAL CONFIGURATOR STATE

     * ----------------------------------------------------------

     */



    const state = {

      configurationId:

        null,



      baseProduct: {
  productId:
    configurator.dataset.productId,

  variantId:
    configurator.dataset.variantId,

  title:
    configurator.dataset.productTitle,

  price:
    configurator.dataset.productPrice,

  stockState:
    configurator.dataset.productStockState
},



      steps:

        {}

    };





    /*

     * ----------------------------------------------------------

     * SESSION STORAGE

     * ----------------------------------------------------------

     */



    const storageKey =

      `lvsh-configurator:${sectionId}`;



    const savedState =

      loadSessionState(

        storageKey

      );



    if (

      savedState &&

      savedState.configurationId

    ) {

      state.configurationId =

        String(

          savedState.configurationId

        );

    } else {

      state.configurationId =

        generateConfigurationId();

    }





    /*

     * ----------------------------------------------------------

     * CONFIGURATION STEPS

     * ----------------------------------------------------------

     */



    const steps =

      configurator.querySelectorAll(

        '[data-config-step]'

      );



    steps.forEach((step) => {

      initialiseStep(

        configurator,

        step,

        state,

        savedState,

        storageKey,

        config

      );

    });





    /*

     * ----------------------------------------------------------

     * MORE INFO DRAWERS

     * ----------------------------------------------------------

     */



    initialiseInfoDrawers(

      configurator,

      state,

      storageKey,

      config

    );





    /*

     * ----------------------------------------------------------

     * ADD TO CART

     * ----------------------------------------------------------

     */



    const addButton =

      configurator.querySelector(

        '[data-config-add]'

      );



    if (addButton) {
  addButton.addEventListener(
    'click',
    () => {
      const presaleUrl =
        addButton.dataset.configPresaleUrl;

      if (presaleUrl) {
        window.open(
          presaleUrl,
          '_blank',
          'noopener'
        );

        return;
      }

      addConfigurationToCart(
        configurator,
        state,
        storageKey,
        addButton,
        config
      );
    }
  );
}





    /*

     * ----------------------------------------------------------

     * INITIAL OUTPUT

     * ----------------------------------------------------------

     */



    saveSessionState(

      storageKey,

      state

    );



    renderReview(

      configurator,

      state,

      config

    );





    /*

     * ----------------------------------------------------------

     * EXPOSE CURRENT STATE

     * ----------------------------------------------------------

     */



    window.LvsHConfigurator =

      window.LvsHConfigurator || {};



    window.LvsHConfigurator.current =

      state;



    window.LvsHConfigurator.instances =

      window.LvsHConfigurator.instances ||

      {};



    window.LvsHConfigurator.instances[

      sectionId

    ] = state;

  }





  /*

   * ============================================================

   * INITIALISE STEP

   * ============================================================

   */



  function initialiseStep(

    configurator,

    step,

    state,

    savedState,

    storageKey,

    config

  ) {

    const blockId =

      step.dataset.blockId;



    const selectionType =

      step.dataset.selectionType;



    const isRequired =

      step.dataset.required ===

      'true';



    const cards =

      Array.from(

        step.querySelectorAll(

          '[data-config-card]'

        )

      );





    /*

     * ----------------------------------------------------------

     * ACCORDION

     * ----------------------------------------------------------

     */



    const tab =

      step.querySelector(

        '[data-config-tab]'

      );



    const content =

      step.querySelector(

        '[data-config-content]'

      );



    if (
  tab &&
  content
) {
  tab.addEventListener(
    'click',
    () => {
      const isOpen =
        step.classList.contains(
          'is-open'
        );

      if (isOpen) {
        step
          .querySelectorAll(
            '[data-config-card].is-info-open'
          )
          .forEach((card) => {
            closeInfoDrawer(card);
          });

        setStepOpen(
          step,
          false
        );

        return;
      }

      configurator
        .querySelectorAll(
          '[data-config-step].is-open'
        )
        .forEach((otherStep) => {
          if (otherStep === step) {
            return;
          }

          otherStep
            .querySelectorAll(
              '[data-config-card].is-info-open'
            )
            .forEach((card) => {
              closeInfoDrawer(card);
            });

          setStepOpen(
            otherStep,
            false
          );
        });

      setStepOpen(
        step,
        true
      );
    }
  );
}





    /*

     * ----------------------------------------------------------

     * REGISTER STEP

     * ----------------------------------------------------------

     */



    state.steps[blockId] = {

      title:

        step.dataset.configTitle || '',



      required:

        isRequired,



      selectionType:

        selectionType,

    minQuantity:
      parseInt(step.dataset.minQuantity || '0', 10) || 0,

    maxQuantity:
      parseInt(step.dataset.maxQuantity || '1', 10) || 1,



      selections:

        []

    };





    /*

     * ----------------------------------------------------------

     * RESTORE SAVED SELECTIONS

     * ----------------------------------------------------------

     */



    let restoredSelection =

      false;



    const savedStep =

      savedState &&

      savedState.steps &&

      savedState.steps[blockId]

        ? savedState.steps[blockId]

        : null;



    const savedSelections =

      savedStep &&

      Array.isArray(

        savedStep.selections

      )

        ? savedStep.selections

        : [];

  if (selectionType === 'quantity') {
    initialiseQuantityStep(configurator, step, cards, savedSelections, state, storageKey, config);
    return;
  }



    if (

      savedSelections.length > 0

    ) {

      savedSelections.forEach(

        (savedSelection) => {

          let matchingCard =

            cards.find(

              (card) =>

                String(

                  card.dataset.variantId

                ) ===

                String(

                  savedSelection.variantId

                )

            );



          /*

           * The saved variant may belong to a sibling rather than

           * the product initially rendered on the card.

           */



          if (!matchingCard) {

            matchingCard =

              cards.find((card) =>

                Array.from(

                  card.querySelectorAll(

                    '[data-sibling-panel]'

                  )

                ).some(

                  (panel) =>

                    String(

                      panel.dataset.siblingVariantId

                    ) ===

                    String(

                      savedSelection.variantId

                    )

                )

              ) || null;



            if (matchingCard) {

              const savedPanel =

                Array.from(

                  matchingCard.querySelectorAll(

                    '[data-sibling-panel]'

                  )

                ).find(

                  (panel) =>

                    String(

                      panel.dataset.siblingVariantId

                    ) ===

                    String(

                      savedSelection.variantId

                    )

                );



              if (savedPanel) {

                applySiblingToCard(

                  matchingCard,

                  savedPanel

                );

              }

            }

          }



          if (!matchingCard) {

            return;

          }



          const button =

            matchingCard.querySelector(

              '[data-config-select]'

            );



          if (

            !button ||

            button.disabled

          ) {

            return;

          }



          if (

            selectionType ===

              'single' &&

            restoredSelection

          ) {

            return;

          }



          setCardSelected(

            matchingCard,

            true

          );



          restoredSelection =

            true;

        }

      );

    }





    /*

     * ----------------------------------------------------------

     * REQUIRED + SINGLE DEFAULT

     * ----------------------------------------------------------

     */



    if (

      isRequired &&

      selectionType === 'single' &&

      !restoredSelection

    ) {

      const firstAvailableCard =

        cards.find((card) => {

          const button =

            card.querySelector(

              '[data-config-select]'

            );



          return (

            button &&

            !button.disabled

          );

        });



      if (firstAvailableCard) {

        setCardSelected(

          firstAvailableCard,

          true

        );

      }

    }





    updateStepState(

      step,

      state

    );



    updateStepInterface(

      step,

      state,

      config

    );





    /*

     * ----------------------------------------------------------

     * CARD CLICK HANDLERS

     * ----------------------------------------------------------

     *

     * The handler is attached even when a card starts disabled.

     * A sibling switch may later make that card selectable.

     */



    cards.forEach((card) => {

      const button =

        card.querySelector(

          '[data-config-select]'

        );



      if (!button) {

        return;

      }



      button.addEventListener(

        'click',

        () => {

          if (button.disabled) {

            return;

          }



          const isCurrentlySelected =

            card.classList.contains(

              'is-selected'

            );



          if (

            selectionType ===

            'single'

          ) {

            if (

              isCurrentlySelected

            ) {

              if (!isRequired) {

                setCardSelected(

                  card,

                  false

                );

              }

            } else {

              cards.forEach(

                (otherCard) => {

                  setCardSelected(

                    otherCard,

                    false

                  );

                }

              );



              setCardSelected(

                card,

                true

              );

            }

          } else {

            setCardSelected(

              card,

              !isCurrentlySelected

            );

          }



          updateStepState(

            step,

            state

          );



          updateStepInterface(

            step,

            state,

            config

          );



          saveSessionState(

            storageKey,

            state

          );



          renderReview(

            configurator,

            state,

            config

          );

        }

      );

    });





    /*

     * ----------------------------------------------------------

     * CLEAR OPTIONAL STEP

     * ----------------------------------------------------------

     */



    const clearButton =

      step.querySelector(

        '[data-config-clear]'

      );



    if (clearButton) {

      clearButton.addEventListener(

        'click',

        () => {

          cards.forEach(

            (card) => {

              setCardSelected(

                card,

                false

              );

            }

          );



          updateStepState(

            step,

            state

          );



          updateStepInterface(

            step,

            state,

            config

          );



          saveSessionState(

            storageKey,

            state

          );



          renderReview(

            configurator,

            state,

            config

          );

        }

      );

    }

  }





  /*

   * ============================================================

   * MORE INFO DRAWER

   * ============================================================

   * Pass 2: informational drawer + sibling switching.

   *

   * The drawer is moved out of the product card and inserted into

   * the flex grid immediately after the last card in the clicked

   * card's visual row.

   *

   * Sibling swatches switch the product represented by the card

   * without navigating away from the configurator.

   */



  function initialiseInfoDrawers(

    configurator,

    state,

    storageKey,

    config

  ) {

    const cards =

      Array.from(

        configurator.querySelectorAll(

          '[data-config-card]'

        )

      );



    cards.forEach((card) => {

      const toggle =

        card.querySelector(

          '[data-info-toggle]'

        );



      const drawer =

        card.querySelector(

          '[data-info-drawer]'

        );



      const drawerInner =

        drawer

          ? drawer.querySelector(

              '[data-info-drawer-inner]'

            )

          : null;



      const closeButton =

        drawer

          ? drawer.querySelector(

              '[data-info-close]'

            )

          : null;



      if (

        !toggle ||

        !drawer ||

        !drawerInner

      ) {

        return;

      }



      /*

       * Stable references are required because the drawer itself

       * is moved out of the card when opened.

       */



      card._lvshInfoDrawer =

        drawer;



      card._lvshInfoDrawerInner =

        drawerInner;



      card._lvshConfiguratorContext = {

        configurator:

          configurator,



        state:

          state,



        storageKey:

          storageKey,



        config:

          config

      };



      toggle.addEventListener(

        'click',

        () => {

          const isOpen =

            card.classList.contains(

              'is-info-open'

            );



          if (isOpen) {

            closeInfoDrawer(

              card

            );

            return;

          }



          closeInfoDrawers(

            configurator

          );



          openInfoDrawer(

            card

          );

        }

      );



      if (closeButton) {

        closeButton.addEventListener(

          'click',

          () => {

            closeInfoDrawer(

              card

            );



            toggle.focus();

          }

        );

      }



      drawer.addEventListener(

        'keydown',

        (event) => {

          if (

            event.key !==

            'Escape'

          ) {

            return;

          }



          closeInfoDrawer(

            card

          );



          toggle.focus();

        }

      );

    });

  }





  /*

   * ============================================================

   * OPEN INFO DRAWER

   * ============================================================

   */



  function openInfoDrawer(

    card

  ) {

    const toggle =

      card.querySelector(

        '[data-info-toggle]'

      );



    const drawer =

      card._lvshInfoDrawer;



    const drawerInner =

      card._lvshInfoDrawerInner;



    const grid =

      card.closest(

        '.lvsh-configurator__grid'

      );



    if (

      !drawer ||

      !drawerInner ||

      !grid

    ) {

      return;

    }



    const panel =

      findInfoPanel(

        card,

        card.dataset.productId

      );



    if (!panel) {

      console.warn(

        '[LvsH Configurator] No More info panel found for product:',

        card.dataset.productId

      );



      return;

    }



    renderInfoPanel(

      card,

      panel,

      drawerInner

    );



    initialiseInfoCarousel(

      drawer

    );



    const lastCardInRow =

      findLastCardInVisualRow(

        card,

        grid

      );



    if (!lastCardInRow) {

      return;

    }



    lastCardInRow.insertAdjacentElement(

      'afterend',

      drawer

    );



    drawer.hidden =

      false;



    card.classList.add(

      'is-info-open'

    );



    if (toggle) {

      toggle.setAttribute(

        'aria-expanded',

        'true'

      );

    }

  }





  /*

   * ============================================================

   * FIND SIBLING PANEL

   * ============================================================

   */



  function findInfoPanel(

    card,

    productId

  ) {

    const panels =

      Array.from(

        card.querySelectorAll(

          '[data-sibling-panel]'

        )

      );



    return (

      panels.find(

        (panel) =>

          String(

            panel.dataset.siblingProductId

          ) ===

          String(

            productId

          )

      ) || null

    );

  }





  /*

   * ============================================================

   * RENDER INFO PANEL

   * ============================================================

   */



  function renderInfoPanel(

    card,

    panel,

    drawerInner

  ) {

    const fragment =

      panel.content.cloneNode(

        true

      );



    /*

     * Nested templates contain the card replacement markup.

     * They are data, not part of the visible drawer.

     */



    fragment

      .querySelectorAll(

        'template'

      )

      .forEach((template) => {

        template.remove();

      });



    drawerInner.replaceChildren(

      fragment

    );



    initialiseSiblingSwatches(

      card

    );

  }





  /*

   * ============================================================

   * SIBLING SWATCHES

   * ============================================================

   */



  function initialiseSiblingSwatches(

    card

  ) {

    const drawer =

      card._lvshInfoDrawer;



    if (!drawer) {

      return;

    }



    drawer

      .querySelectorAll(

        '[data-sibling-swatch]'

      )

      .forEach((swatch) => {

        swatch.addEventListener(

          'click',

          () => {

            const targetProductId =

              swatch.dataset.siblingTarget;



            if (!targetProductId) {

              return;

            }



            switchCardSibling(

              card,

              targetProductId

            );

          }

        );

      });

  }





  /*

   * ============================================================

   * SWITCH ACTIVE SIBLING

   * ============================================================

   */



  function switchCardSibling(

    card,

    productId

  ) {

    const context =

      card._lvshConfiguratorContext;



    const drawer =

      card._lvshInfoDrawer;



    const drawerInner =

      card._lvshInfoDrawerInner;



    if (

      !context ||

      !drawer ||

      !drawerInner

    ) {

      return;

    }



    const panel =

      findInfoPanel(

        card,

        productId

      );



    if (!panel) {

      console.warn(

        '[LvsH Configurator] No sibling panel found for product:',

        productId

      );



      return;

    }



    const wasSelected =

      card.classList.contains(

        'is-selected'

      );



    if (

      String(

        card.dataset.productId

      ) ===

      String(

        productId

      )

    ) {

      return;

    }



    /*

     * First update the card itself.

     */



    applySiblingToCard(

      card,

      panel

    );



    /*

     * Then rebuild the open drawer for the newly active sibling.

     */



    renderInfoPanel(

      card,

      panel,

      drawerInner

    );



    initialiseInfoCarousel(

      drawer

    );



    /*

     * A selected product must never remain selected after it

     * changes to a product that cannot be purchased online.

     */



    reconcileSiblingSelection(

      card,

      wasSelected

    );



    const step =

      card.closest(

        '[data-config-step]'

      );



    if (step) {

      updateStepState(

        step,

        context.state

      );



      updateStepInterface(

        step,

        context.state,

        context.config

      );

    }



    saveSessionState(

      context.storageKey,

      context.state

    );



    renderReview(

      context.configurator,

      context.state,

      context.config

    );

  }





  /*

   * ============================================================

   * APPLY SIBLING TO CARD

   * ============================================================

   */



  function applySiblingToCard(

    card,

    panel

  ) {

    const productId =

      panel.dataset.siblingProductId;



    const variantId =

      panel.dataset.siblingVariantId;



    const title =

      panel.dataset.siblingTitle ||

      '';



    const price =

      panel.dataset.siblingPrice ||

      '0';



    const stockState =

      panel.dataset.siblingStockState ||

      'out_of_stock';



    const selectable =

      panel.dataset.siblingSelectable ===

      'true';





    /*

     * Product identity used by selection/review/cart.

     */



    card.dataset.productId =

      productId || '';



    card.dataset.variantId =

      variantId || '';



    card.dataset.productTitle =

      title;



    card.dataset.price =

      price;



    card.dataset.stockState =

      stockState;





    /*

     * Visual availability state.

     */



    card.classList.toggle(

      'is-unavailable',

      !selectable

    );





    /*

     * Title.

     */



    const titleElement =

      card.querySelector(

        '[data-config-card-title]'

      );



    if (titleElement) {

      titleElement.textContent =

        title;

    }





    /*

     * Image, price and stock status are supplied by the hidden

     * Liquid templates for the selected sibling.

     */



    replaceCardTemplateContent(

      card,

      panel,

      '[data-config-card-image]',

      '[data-card-image-template]'

    );



    replaceCardTemplateContent(

      card,

      panel,

      '[data-config-card-price]',

      '[data-card-price-template]'

    );



    replaceCardTemplateContent(

      card,

      panel,

      '[data-config-card-status]',

      '[data-card-status-template]'

    );





    /*

     * CTA state.

     */



    const selectButton =

      card.querySelector(

        '[data-config-select]'

      );



    const dealerButton =

      card.querySelector(

        '[data-config-dealer]'

      );

    const quantityControl = card.querySelector('[data-config-quantity]');



    if (selectButton) {

      selectButton.disabled =

        !selectable;



      selectButton.hidden =

        stockState ===

        'presale';

    }



    if (dealerButton) {

      dealerButton.hidden =

        stockState !==

        'presale';

    }

    if (quantityControl) {
      quantityControl.hidden = !selectable;
    }





    /*

     * If the card remains selected after an available-to-available

     * sibling change, preserve its selected button label.

     */



    if (

      card.classList.contains(

        'is-selected'

      ) &&

      selectButton &&

      !selectButton.disabled

    ) {

      selectButton.textContent =

        selectButton.dataset.selectedLabel ||

        'Selected';

    }

  }





  /*

   * ============================================================

   * REPLACE CARD CONTENT FROM LIQUID TEMPLATE

   * ============================================================

   */



  function replaceCardTemplateContent(

    card,

    panel,

    targetSelector,

    templateSelector

  ) {

    const target =

      card.querySelector(

        targetSelector

      );



    const template =

      panel.content.querySelector(

        templateSelector

      );



    if (

      !target ||

      !template

    ) {

      return;

    }



    target.replaceChildren(

      template.content.cloneNode(

        true

      )

    );

  }





  /*

   * ============================================================

   * RECONCILE SELECTION AFTER SIBLING CHANGE

   * ============================================================

   */



  function reconcileSiblingSelection(card, wasSelected) {
    if (!wasSelected) return;

    const step = card.closest('[data-config-step]');
    if (!step) return;

    if (step.dataset.selectionType === 'quantity') {
      const selectable = card.dataset.stockState === 'in_stock';
      if (selectable) {
        setCardQuantity(card, getCardQuantity(card));
        updateQuantityControls(step);
        return;
      }

      setCardQuantity(card, 0);
      updateQuantityControls(step);
      if (getStepMinQuantity(step) > 0 && getStepTotalQuantity(step) < getStepMinQuantity(step)) {
        step.dataset.requiredAttention = 'true';
      }
      return;
    }

    const selectButton = card.querySelector('[data-config-select]');
    if (selectButton && !selectButton.disabled) {
      setCardSelected(card, true);
      return;
    }

    setCardSelected(card, false);
    if (step.dataset.required === 'true' && getSelections(step).length === 0) {
      step.dataset.requiredAttention = 'true';
    }
  }


  /*
   * ============================================================
   * FIND LAST CARD IN VISUAL ROW
   * ============================================================
   */

  function findLastCardInVisualRow(

    card,

    grid

  ) {

    const rowTop =

      card.offsetTop;



    const rowCards =

      Array.from(

        grid.querySelectorAll(

          ':scope > [data-config-card]'

        )

      ).filter(

        (rowCard) =>

          Math.abs(

            rowCard.offsetTop -

            rowTop

          ) < 2

      );



    return (

      rowCards.length > 0

        ? rowCards[

            rowCards.length - 1

          ]

        : card

    );

  }





  /*

   * ============================================================

   * IMAGE CAROUSEL

   * ============================================================

   */



  function initialiseInfoCarousel(

    drawer

  ) {

    const imagesContainer =

      drawer.querySelector(

        '.lvsh-info-drawer__images'

      );



    if (!imagesContainer) {

      return;

    }



    const slides =

      Array.from(

        imagesContainer.querySelectorAll(

          ':scope > .lvsh-info-drawer__image'

        )

      );



    if (

      slides.length === 0

    ) {

      return;

    }



    let activeIndex =

      0;



    const controls =

      document.createElement(

        'div'

      );



    controls.className =

      'lvsh-info-drawer__carousel-controls';



    const previousButton =

      document.createElement(

        'button'

      );



    previousButton.type =

      'button';



    previousButton.className =

      'lvsh-info-drawer__carousel-button lvsh-info-drawer__carousel-button--previous';



    previousButton.setAttribute(

      'aria-label',

      'Previous image'

    );



    previousButton.innerHTML =

      '<span aria-hidden="true">‹</span>';



    const nextButton =

      document.createElement(

        'button'

      );



    nextButton.type =

      'button';



    nextButton.className =

      'lvsh-info-drawer__carousel-button lvsh-info-drawer__carousel-button--next';



    nextButton.setAttribute(

      'aria-label',

      'Next image'

    );



    nextButton.innerHTML =

      '<span aria-hidden="true">›</span>';



    const counter =

      document.createElement(

        'div'

      );



    counter.className =

      'lvsh-info-drawer__carousel-counter';



    counter.setAttribute(

      'aria-live',

      'polite'

    );



    controls.append(

      previousButton,

      nextButton,

      counter

    );



    imagesContainer.append(

      controls

    );



    function renderCarousel() {

      slides.forEach(

        (slide, index) => {

          const isActive =

            index ===

            activeIndex;



          slide.hidden =

            !isActive;



          slide.classList.toggle(

            'is-active',

            isActive

          );



          slide.setAttribute(

            'aria-hidden',

            isActive

              ? 'false'

              : 'true'

          );

        }

      );



      counter.textContent =

        `${activeIndex + 1} / ${slides.length}`;



      const hasMultipleImages =

        slides.length > 1;



      previousButton.hidden =

        !hasMultipleImages;



      nextButton.hidden =

        !hasMultipleImages;



      counter.hidden =

        !hasMultipleImages;

    }



    previousButton.addEventListener(

      'click',

      () => {

        activeIndex =

          (

            activeIndex -

            1 +

            slides.length

          ) %

          slides.length;



        renderCarousel();

      }

    );



    nextButton.addEventListener(

      'click',

      () => {

        activeIndex =

          (

            activeIndex +

            1

          ) %

          slides.length;



        renderCarousel();

      }

    );



    renderCarousel();

  }



    /*

   * ============================================================

   * CLOSE DRAWERS

   * ============================================================

   */



  function closeInfoDrawers(

    configurator,

    exceptCard = null

  ) {

    configurator

      .querySelectorAll(

        '[data-config-card].is-info-open'

      )

      .forEach((card) => {

        if (

          card !==

          exceptCard

        ) {

          closeInfoDrawer(

            card

          );

        }

      });

  }





  function closeInfoDrawer(

    card

  ) {

    const toggle =

      card.querySelector(

        '[data-info-toggle]'

      );



    const drawer =

      card._lvshInfoDrawer;



    const drawerInner =

      card._lvshInfoDrawerInner;



    if (drawer) {

      drawer.hidden =

        true;

    }



    if (drawerInner) {

      drawerInner.replaceChildren();

    }



    if (toggle) {

      toggle.setAttribute(

        'aria-expanded',

        'false'

      );

    }



    card.classList.remove(

      'is-info-open'

    );

  }





  /*

   * ============================================================

   * RESPONSIVE ROW POSITION

   * ============================================================

   */



  function repositionOpenInfoDrawers() {

    document

      .querySelectorAll(

        '[data-config-card].is-info-open'

      )

      .forEach((card) => {

        const drawer =

          card._lvshInfoDrawer;



        const grid =

          card.closest(

            '.lvsh-configurator__grid'

          );



        if (

          !drawer ||

          drawer.hidden ||

          !grid

        ) {

          return;

        }



        const lastCardInRow =

          findLastCardInVisualRow(

            card,

            grid

          );



        if (

          lastCardInRow &&

          drawer.previousElementSibling !==

            lastCardInRow

        ) {

          lastCardInRow.insertAdjacentElement(

            'afterend',

            drawer

          );

        }

      });

  }



  window.addEventListener(

    'resize',

    repositionOpenInfoDrawers

  );





  /*

   * ============================================================

   * ACCORDION STATE

   * ============================================================

   */



  function setStepOpen(

    step,

    open

  ) {

    const tab =

      step.querySelector(

        '[data-config-tab]'

      );



    const content =

      step.querySelector(

        '[data-config-content]'

      );



    step.classList.toggle(

      'is-open',

      open

    );



    if (tab) {

      tab.setAttribute(

        'aria-expanded',

        open

          ? 'true'

          : 'false'

      );

    }



    if (content) {

      content.hidden =

        !open;

    }

  }





  /*

   * ============================================================

   * UPDATE STEP HEADER / CONTROLS

   * ============================================================

   */



  function updateStepInterface(step, state, config) {
    const blockId = step.dataset.blockId;
    const stepState = state.steps[blockId];
    if (!stepState) return;

    const selections = Array.isArray(stepState.selections) ? stepState.selections : [];
    const isQuantityStep = stepState.selectionType === 'quantity';
    const totalQuantity = isQuantityStep
      ? selections.reduce((total, selection) => total + (parseInt(selection.quantity, 10) || 0), 0)
      : selections.length;
    const minimumRequired = isQuantityStep
      ? (parseInt(stepState.minQuantity, 10) || 0)
      : (stepState.required ? 1 : 0);

    if (totalQuantity >= minimumRequired && totalQuantity > 0) {
      step.dataset.requiredAttention = 'false';
    }

    step.classList.toggle(
      'has-required-error',
      minimumRequired > 0 && totalQuantity < minimumRequired && step.dataset.requiredAttention === 'true'
    );

    const summary = step.querySelector('[data-config-summary]');
    if (summary) {
      if (totalQuantity === 0) {
        summary.textContent = getLabel(config, 'noneSelected', 'None selected');
      } else if (isQuantityStep && selections.length === 1) {
        summary.textContent = `${selections[0].title} × ${selections[0].quantity}`;
      } else if (isQuantityStep) {
        summary.textContent = `${totalQuantity} selected`;
      } else if (selections.length === 1) {
        summary.textContent = selections[0].title;
      } else {
        summary.textContent = `${selections.length} selected`;
      }
    }

    const clearRow = step.querySelector('[data-config-clear-row]');
    if (clearRow) clearRow.hidden = selections.length === 0;
    if (isQuantityStep) updateQuantityControls(step);
  }


  /*
   * ============================================================
   * QUANTITY STEPS
   * ============================================================
   */

  function initialiseQuantityStep(configurator, step, cards, savedSelections, state, storageKey, config) {
    savedSelections.forEach((savedSelection) => {
      const savedQuantity = Math.max(0, parseInt(savedSelection.quantity, 10) || 0);
      if (savedQuantity === 0) return;

      let matchingCard = cards.find((card) =>
        String(card.dataset.variantId) === String(savedSelection.variantId)
      );

      if (!matchingCard) {
        matchingCard = cards.find((card) =>
          Array.from(card.querySelectorAll('[data-sibling-panel]')).some((panel) =>
            String(panel.dataset.siblingVariantId) === String(savedSelection.variantId)
          )
        ) || null;

        if (matchingCard) {
          const savedPanel = Array.from(matchingCard.querySelectorAll('[data-sibling-panel]')).find((panel) =>
            String(panel.dataset.siblingVariantId) === String(savedSelection.variantId)
          );
          if (savedPanel) applySiblingToCard(matchingCard, savedPanel);
        }
      }

      if (!matchingCard || matchingCard.dataset.stockState !== 'in_stock') return;

      const remaining = getStepMaxQuantity(step) - getStepTotalQuantity(step);
      setCardQuantity(matchingCard, Math.min(savedQuantity, Math.max(0, remaining)));
    });

    /*
     * Use one delegated click handler for the whole quantity step.
     * This remains reliable even when card content is updated after
     * sibling switching, because the listener stays on the step.
     */
    step.addEventListener('click', (event) => {
      const button = event.target.closest(
        '[data-quantity-choice], [data-quantity-minus], [data-quantity-plus], [data-quantity-clear]'
      );

      if (!button || !step.contains(button) || button.disabled) return;

      const card = button.closest('[data-config-card]');
      if (!card || card.dataset.stockState !== 'in_stock') return;

      if (button.matches('[data-quantity-choice]')) {
        setQuantityFromUser(
          card,
          parseInt(button.dataset.quantityChoice, 10) || 0,
          step
        );
      } else if (button.matches('[data-quantity-minus]')) {
        setQuantityFromUser(card, Math.max(0, getCardQuantity(card) - 1), step);
      } else if (button.matches('[data-quantity-plus]')) {
        setQuantityFromUser(card, getCardQuantity(card) + 1, step);
      } else if (button.matches('[data-quantity-clear]')) {
        if (getCardQuantity(card) === 0) return;
        setQuantityFromUser(card, 0, step);
      }

      commitQuantityStep(configurator, step, state, storageKey, config);
    }, true);

    updateStepState(step, state);

const initialTotalQuantity =
  getStepTotalQuantity(step);

const initialMinimumQuantity =
  getStepMinQuantity(step);

if (
  initialMinimumQuantity > 0 &&
  initialTotalQuantity < initialMinimumQuantity
) {
  step.dataset.requiredAttention =
    'true';
}

updateStepInterface(step, state, config);
  }

  function commitQuantityStep(configurator, step, state, storageKey, config) {
    updateQuantityControls(step);
    updateStepState(step, state);
    updateStepInterface(step, state, config);
    saveSessionState(storageKey, state);
    renderReview(configurator, state, config);
  }

  function setQuantityFromUser(card, quantity, step) {
    const previousQuantity = getCardQuantity(card);
    const otherQuantity = getStepTotalQuantity(step) - previousQuantity;
    const maxQuantity = getStepMaxQuantity(step);
    const nextQuantity = Math.max(0, Math.min(quantity, maxQuantity - otherQuantity));
    setCardQuantity(card, nextQuantity);

    const minQuantity = getStepMinQuantity(step);
    if (getStepTotalQuantity(step) >= minQuantity) return;

    if (nextQuantity === 0 && previousQuantity > 0 && minQuantity === 1) {
      const replacement = Array.from(step.querySelectorAll('[data-config-card]')).find((otherCard) =>
        otherCard !== card &&
        otherCard.dataset.stockState === 'in_stock' &&
        getCardQuantity(otherCard) === 0
      );

      if (replacement) {
        setCardQuantity(replacement, 1);
        return;
      }
    }

    if (minQuantity > 0) {
      step.dataset.requiredAttention = 'true';
    }
  }

  function setCardQuantity(card, quantity) {
    const safeQuantity = Math.max(0, parseInt(quantity, 10) || 0);
    card.dataset.quantity = String(safeQuantity);
    card.dataset.selected = safeQuantity > 0 ? 'true' : 'false';
    card.classList.toggle('is-selected', safeQuantity > 0);

    const value = card.querySelector('[data-quantity-value]');
    if (value) value.textContent = String(safeQuantity);
    const clear = card.querySelector('[data-quantity-clear]');
    if (clear) clear.hidden = safeQuantity === 0;

    card.querySelectorAll('[data-quantity-choice]').forEach((button) => {
  const active = (parseInt(button.dataset.quantityChoice, 10) || 0) === safeQuantity;
  button.classList.toggle('is-active', active);
  button.setAttribute('aria-pressed', active ? 'true' : 'false');
});
  }

  function getCardQuantity(card) {
    return Math.max(0, parseInt(card.dataset.quantity, 10) || 0);
  }

  function getStepTotalQuantity(step) {
    return Array.from(step.querySelectorAll('[data-config-card]')).reduce(
      (total, card) => total + getCardQuantity(card), 0
    );
  }

  function getStepMinQuantity(step) {
    return Math.max(0, parseInt(step.dataset.minQuantity, 10) || 0);
  }

  function getStepMaxQuantity(step) {
    return Math.max(1, parseInt(step.dataset.maxQuantity, 10) || 1);
  }

  function updateQuantityControls(step) {
    const totalQuantity = getStepTotalQuantity(step);
    const maxQuantity = getStepMaxQuantity(step);

    step.querySelectorAll('[data-config-card]').forEach((card) => {
      const currentQuantity = getCardQuantity(card);
      const otherQuantity = totalQuantity - currentQuantity;
      const selectable = card.dataset.stockState === 'in_stock';
      const control = card.querySelector('[data-config-quantity]');
      if (control) control.hidden = !selectable;

      card.querySelectorAll('[data-quantity-choice]').forEach((button) => {
        const buttonQuantity = parseInt(button.dataset.quantityChoice, 10) || 0;
        button.disabled = !selectable || (otherQuantity + buttonQuantity > maxQuantity);
      });

      const minus = card.querySelector('[data-quantity-minus]');
      const plus = card.querySelector('[data-quantity-plus]');
      const clear = card.querySelector('[data-quantity-clear]');
      if (minus) minus.disabled = !selectable || currentQuantity === 0;
      if (plus) plus.disabled = !selectable || totalQuantity >= maxQuantity;
      if (clear) clear.hidden = currentQuantity === 0;
    });
  }


  /*
   * ============================================================
   * SET CARD SELECTION
   * ============================================================
   */

  function setCardSelected(

    card,

    selected

  ) {

    const button =

      card.querySelector(

        '[data-config-select]'

      );



    if (!button) {

      return;

    }



    /*

     * Disabled cards cannot become selected, but they CAN be

     * unselected. This matters when an already-selected card is

     * switched to a pre-order or out-of-stock sibling.

     */



    if (

      selected &&

      button.disabled

    ) {

      return;

    }



    card.classList.toggle(

      'is-selected',

      selected

    );



    card.dataset.selected =

      selected

        ? 'true'

        : 'false';



    button.classList.toggle(

      'btn--primary',

      selected

    );



    button.classList.toggle(

      'btn--secondary',

      !selected

    );



    button.setAttribute(

      'aria-pressed',

      selected

        ? 'true'

        : 'false'

    );



    if (

      card.getAttribute(

        'role'

      ) ===

      'radio'

    ) {

      card.setAttribute(

        'aria-checked',

        selected

          ? 'true'

          : 'false'

      );

    }



    const defaultLabel =

      button.dataset.defaultLabel ||

      'Select';



    const selectedLabel =

      button.dataset.selectedLabel ||

      'Selected';



    button.textContent =

      selected

        ? selectedLabel

        : defaultLabel;

  }





  /*

   * ============================================================

   * READ STEP SELECTIONS

   * ============================================================

   */



  function getSelections(step) {
    const isQuantityStep = step.dataset.selectionType === 'quantity';
    return Array.from(
      step.querySelectorAll('[data-config-card][data-selected="true"]')
    ).map((card) => ({
      productId: card.dataset.productId,
      variantId: card.dataset.variantId,
      title: card.dataset.productTitle,
      price: card.dataset.price,
      quantity: isQuantityStep ? getCardQuantity(card) : 1
    })).filter((selection) => selection.quantity > 0);
  }


  /*
   * ============================================================
   * UPDATE STEP STATE
   * ============================================================
   */

  function updateStepState(

    step,

    state

  ) {

    const blockId =

      step.dataset.blockId;



    state.steps[

      blockId

    ] = {

      title:

        step.dataset.configTitle ||

        '',



      required:

        step.dataset.required ===

        'true',



      selectionType:

        step.dataset.selectionType,

    minQuantity: getStepMinQuantity(step),
    maxQuantity: getStepMaxQuantity(step),



      selections:

        getSelections(

          step

        )

    };

  }





  /*

   * ============================================================

   * SESSION STORAGE

   * ============================================================

   */



  function loadSessionState(

    storageKey

  ) {

    try {

      const stored =

        window.sessionStorage.getItem(

          storageKey

        );



      if (!stored) {

        return null;

      }



      const parsed =

        JSON.parse(

          stored

        );



      if (

        !parsed ||

        typeof parsed !==

          'object'

      ) {

        return null;

      }



      return parsed;

    } catch (error) {

      console.warn(

        '[LvsH Configurator] Could not restore session state:',

        error

      );



      return null;

    }

  }





  function saveSessionState(

    storageKey,

    state

  ) {

    try {

      const persistentState = {

        configurationId:

          state.configurationId,



        steps:

          {}

      };



      Object.entries(

        state.steps

      ).forEach(

        ([blockId, step]) => {

          persistentState.steps[

            blockId

          ] = {

            selections:

              Array.isArray(

                step.selections

              )

                ? step.selections

                : []

          };

        }

      );



      window.sessionStorage.setItem(

        storageKey,

        JSON.stringify(

          persistentState

        )

      );

    } catch (error) {

      console.warn(

        '[LvsH Configurator] Could not save session state:',

        error

      );

    }

  }





  /*

   * ============================================================

   * REVIEW

   * ============================================================

   */



  function renderReview(

    configurator,

    state,

    config

  ) {

    const content =

      configurator.querySelector(

        '[data-config-review-content]'

      );



    const totalElement =

      configurator.querySelector(

        '[data-config-review-total]'

      );



    const addButton =

      configurator.querySelector(

        '[data-config-add]'

      );



    if (!content) {

      return;

    }



    let html =

      '';



    let totalPrice =

      0;



    let configurationValid =

      true;





    /*

     * ----------------------------------------------------------

     * BASE BIKE

     * ----------------------------------------------------------

     */



    if (

      state.baseProduct &&

      state.baseProduct.variantId

    ) {

      const basePrice =

        parseInt(

          state.baseProduct.price,

          10

        ) || 0;



      totalPrice +=

        basePrice;



      html += `

        <div class="lvsh-configurator__review-group">



          <div class="lvsh-configurator__review-group-title">

            ${escapeHtml(

              getLabel(

                config,

                'bike',

                'Bike'

              )

            )}

          </div>



          <div class="lvsh-configurator__review-item">



            <span class="lvsh-configurator__review-item-title">

              ${escapeHtml(

                state.baseProduct.title

              )}

            </span>



            <span class="lvsh-configurator__review-item-price">

              ${formatMoney(

                basePrice,

                config

              )}

            </span>



          </div>



        </div>

      `;

    } else {

      configurationValid =

        false;

    }





    /*

     * ----------------------------------------------------------

     * CONFIGURATION STEPS

     * ----------------------------------------------------------

     */



    Object.values(

      state.steps

    ).forEach((step) => {

      const selections =

        Array.isArray(

          step.selections

        )

          ? step.selections

          : [];



      const stepQuantity = selections.reduce(
      (total, selection) => total + (parseInt(selection.quantity, 10) || 1), 0
    );
    const minimumRequired = step.selectionType === 'quantity'
      ? (parseInt(step.minQuantity, 10) || 0)
      : (step.required ? 1 : 0);
    if (stepQuantity < minimumRequired) {
      configurationValid = false;
    }



      html += `

        <div class="lvsh-configurator__review-group">



          <div class="lvsh-configurator__review-group-title">

            ${escapeHtml(

              step.title

            )}

          </div>

      `;



      if (

        selections.length === 0

      ) {

        html += `

          <div class="lvsh-configurator__review-empty">

            ${escapeHtml(

              getLabel(

                config,

                'noneSelected',

                'None selected'

              )

            )}

          </div>

        `;

      }



      selections.forEach(

        (selection) => {

          const price =

            parseInt(

              selection.price,

              10

            ) || 0;



          const quantity = Math.max(1, parseInt(selection.quantity, 10) || 1);

        totalPrice += price * quantity;



          html += `

            <div class="lvsh-configurator__review-item">



              <span class="lvsh-configurator__review-item-title">

                ${escapeHtml(

                  selection.title

                )}

              </span>



              <span class="lvsh-configurator__review-item-price">

                ${formatMoney(

                  price * quantity,

                  config

                )}

              </span>



            </div>

          `;

        }

      );



      html += `

        </div>

      `;

    });





    /*

     * ----------------------------------------------------------

     * OUTPUT

     * ----------------------------------------------------------

     */



    content.innerHTML =

      html;



    if (totalElement) {

      totalElement.textContent =

        formatMoney(

          totalPrice,

          config

        );

    }



    if (
  addButton &&
  addButton.getAttribute(
    'aria-busy'
  ) !== 'true'
) {
  const baseProductPresale =
    state.baseProduct &&
    state.baseProduct.stockState ===
      'presale';

  const normalLabel =
    getLabel(
      config,
      'addToCart',
      'Add configuration to cart'
    );

  const invalidLabel =
    getLabel(
      config,
      'invalidConfiguration',
      'Add to cart unavailable – configuration is incomplete'
    );

  const presaleLabel =
    getLabel(
      config,
      'baseProductPresale',
      'Currently sold out – Pre-order with your local dealer'
    );

  const presaleUrl =
    config &&
    config.baseProductPresaleUrl
      ? config.baseProductPresaleUrl
      : '';

  /*
   * Reset the CTA before applying its current state.
   */
  addButton.disabled = false;

  addButton.classList.remove(
    'btn--secondary',
    'lvsh-configurator__add-button--presale'
  );

  addButton.classList.add(
    'btn--primary'
  );

  addButton.removeAttribute(
    'data-config-presale-url'
  );

  /*
   * Configuration completeness takes priority.
   *
   * This lets the customer see that the build still needs
   * attention before we present the dealer route.
   */
  if (!configurationValid) {
    addButton.disabled = true;

    addButton.textContent =
      invalidLabel;

  } else if (baseProductPresale) {
    addButton.classList.remove(
      'btn--primary'
    );

    addButton.classList.add(
      'btn--secondary',
      'lvsh-configurator__add-button--presale'
    );

    addButton.textContent =
      presaleLabel;

    if (presaleUrl) {
      addButton.dataset.configPresaleUrl =
        presaleUrl;
    } else {
      /*
       * Without a configured destination the dealer CTA
       * must not become a dead button.
       */
      addButton.disabled = true;
    }

  } else {
    addButton.textContent =
      normalLabel;
  }
}
  
}





  /*

   * ============================================================

   * CONFIGURATION ID

   * ============================================================

   */



  function generateConfigurationId() {

    return (

      Date.now().toString() +

      Math.floor(

        Math.random() *

        1000000

      ).toString()

    );

  }





  /*

   * ============================================================

   * COLLECT CART ITEMS

   * ============================================================

   */



  function getConfigurationItems(state) {
    const items = [];
    if (!state.baseProduct || !state.baseProduct.variantId) {
      throw new Error('No base product found.');
    }
    if (
  state.baseProduct.stockState ===
  'presale'
) {
  throw new Error(
    'Base product is available for pre-order only and cannot be added to cart online.'
  );
}

    items.push({ variantId: state.baseProduct.variantId, title: state.baseProduct.title, quantity: 1 });

    Object.values(state.steps).forEach((step) => {
      const selections = Array.isArray(step.selections) ? step.selections : [];
      const totalQuantity = selections.reduce(
        (total, selection) => total + (parseInt(selection.quantity, 10) || 1), 0
      );
      const minimumRequired = step.selectionType === 'quantity'
        ? (parseInt(step.minQuantity, 10) || 0)
        : (step.required ? 1 : 0);

      if (totalQuantity < minimumRequired) {
        throw new Error(`Required configuration step "${step.title}" has not met its minimum quantity.`);
      }

      selections.forEach((selection) => {
        if (!selection.variantId) {
          throw new Error(`No variant ID found for "${selection.title}".`);
        }
        items.push({
          variantId: selection.variantId,
          title: selection.title,
          quantity: Math.max(1, parseInt(selection.quantity, 10) || 1)
        });
      });
    });

    return items;
  }


  /*
   * ============================================================
   * ADD COMPLETE CONFIGURATION TO CART
   * ============================================================
   */

  async function addConfigurationToCart(

    configurator,

    state,

    storageKey,

    button,

    config

  ) {

    const configurationId =

      state.configurationId;



    if (!configurationId) {

      console.error(

        '[LvsH Configurator] No configuration ID found.'

      );



      return;

    }



    let configurationItems;



    try {

      configurationItems =

        getConfigurationItems(

          state

        );

    } catch (error) {

      console.error(

        '[LvsH Configurator] Configuration validation failed:',

        error

      );



      return;

    }



    const payload = {

      items:

        configurationItems.map(

          (item) => ({

            id:

              Number(

                item.variantId

              ),



            quantity:

            Math.max(1, parseInt(item.quantity, 10) || 1),



            properties: {

              _configurator_id:

                configurationId

            }

          })

        )

    };



    console.log(

      '[LvsH Configurator] Adding configuration:',

      {

        configurationId:

          configurationId,



        items:

          configurationItems,



        payload:

          payload

      }

    );



    const originalButtonText =

      button.textContent.trim();



    button.disabled =

      true;



    button.setAttribute(

      'aria-busy',

      'true'

    );



    button.textContent =

      'Adding…';



    try {

      let cartAddRoute;



      if (

        window.theme &&

        window.theme.routes &&

        window.theme.routes.cartAdd

      ) {

        cartAddRoute =

          window.theme.routes.cartAdd;

      } else {

        const cartRoot =

          window.Shopify &&

          window.Shopify.routes &&

          window.Shopify.routes.root

            ? window.Shopify.routes.root

            : '/';



        cartAddRoute =

          `${cartRoot}cart/add.js`;

      }



      const response =

        await fetch(

          cartAddRoute,

          {

            method:

              'POST',



            headers: {

              'Accept':

                'application/json',



              'Content-Type':

                'application/json'

            },



            body:

              JSON.stringify(

                payload

              )

          }

        );



      const responseData =

        await response.json();



      if (!response.ok) {

        throw new Error(

          responseData.description ||

          responseData.message ||

          `Cart request failed with status ${response.status}.`

        );

      }



      console.log(

        '[LvsH Configurator] Configuration added successfully:',

        responseData

      );





      /*

       * --------------------------------------------------------

       * NEW ID FOR THE NEXT BUILD

       * --------------------------------------------------------

       */



      const previousConfigurationId =

        state.configurationId;



      state.configurationId =

        generateConfigurationId();



      saveSessionState(

        storageKey,

        state

      );



      console.log(

        '[LvsH Configurator] Configuration ID reset:',

        {

          previous:

            previousConfigurationId,



          next:

            state.configurationId

        }

      );



      if (

        window.LvsHConfigurator

      ) {

        window.LvsHConfigurator.current =

          state;



        if (

          window.LvsHConfigurator.instances

        ) {

          window.LvsHConfigurator.instances[

            String(

              config.sectionId

            )

          ] = state;

        }

      }





      /*

       * --------------------------------------------------------

       * REFRESH CART DRAWER

       * --------------------------------------------------------

       */



      document.dispatchEvent(

        new CustomEvent(

          'dispatch:cart-drawer:refresh',

          {

            bubbles:

              true

          }

        )

      );



      setTimeout(

        () => {

          document.dispatchEvent(

            new CustomEvent(

              'dispatch:cart-drawer:open',

              {

                bubbles:

                  true

              }

            )

          );

        },

        150

      );



    } catch (error) {

      console.error(

        '[LvsH Configurator] Failed to add configuration:',

        error

      );



    } finally {

      button.removeAttribute(

        'aria-busy'

      );



      button.textContent =

        originalButtonText;



      renderReview(

        configurator,

        state,

        config

      );

    }

  }





  /*

   * ============================================================

   * LABEL HELPER

   * ============================================================

   */



  function getLabel(

    config,

    key,

    fallback

  ) {

    if (

      config &&

      config.labels &&

      typeof config.labels[key] ===

        'string' &&

      config.labels[key]

    ) {

      return config.labels[

        key

      ];

    }



    return fallback;

  }





  /*

   * ============================================================

   * MONEY FORMATTING

   * ============================================================

   */



  function formatMoney(

    cents,

    config

  ) {

    const amount =

      Number(

        cents || 0

      );



    const format =

      config &&

      config.moneyFormat

        ? config.moneyFormat

        : '${{amount}}';



    function formatWithDelimiters(

      number,

      precision = 2,

      thousands = ',',

      decimal = '.'

    ) {

      if (

        number === null ||

        isNaN(

          number

        )

      ) {

        return '0';

      }



      const fixed =

        (

          number /

          100

        ).toFixed(

          precision

        );



      const parts =

        fixed.split(

          '.'

        );



      const dollars =

        parts[0].replace(

          /(\d)(?=(\d\d\d)+(?!\d))/g,

          `$1${thousands}`

        );



      const centsPart =

        parts[1]

          ? decimal +

            parts[1]

          : '';



      return (

        dollars +

        centsPart

      );

    }



    let value =

      '';



    if (

      format.indexOf(

        '{{amount_no_decimals_with_comma_separator}}'

      ) !== -1

    ) {

      value =

        formatWithDelimiters(

          amount,

          0,

          '.',

          ','

        );



      return format.replace(

        '{{amount_no_decimals_with_comma_separator}}',

        value

      );

    }



    if (

      format.indexOf(

        '{{amount_with_comma_separator}}'

      ) !== -1

    ) {

      value =

        formatWithDelimiters(

          amount,

          2,

          '.',

          ','

        );



      return format.replace(

        '{{amount_with_comma_separator}}',

        value

      );

    }



    if (

      format.indexOf(

        '{{amount_no_decimals}}'

      ) !== -1

    ) {

      value =

        formatWithDelimiters(

          amount,

          0

        );



      return format.replace(

        '{{amount_no_decimals}}',

        value

      );

    }



    value =

      formatWithDelimiters(

        amount,

        2

      );



    return format.replace(

      '{{amount}}',

      value

    );

  }





  /*

   * ============================================================

   * ESCAPE HTML

   * ============================================================

   */



  function escapeHtml(

    value

  ) {

    const div =

      document.createElement(

        'div'

      );



    div.textContent =

      value == null

        ? ''

        : String(

            value

          );



    return div.innerHTML;

  }





  /*

   * ============================================================

   * INITIAL PAGE LOAD

   * ============================================================

   */



  if (

    document.readyState ===

    'loading'

  ) {

    document.addEventListener(

      'DOMContentLoaded',

      () => {

        initAllConfigurators();

      }

    );

  } else {

    initAllConfigurators();

  }





  /*

   * ============================================================

   * SHOPIFY THEME EDITOR

   * ============================================================

   */



  document.addEventListener(

    'shopify:section:load',

    (event) => {

      initAllConfigurators(

        event.target

      );

    }

  );



})();